"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.ExpeditionType=void 0;var i;(function(e){e.Delivery="delivery",e.PickUp="pick-up",e.Pickup="pickup"})(i||(exports.ExpeditionType=i={}));
//# sourceMappingURL=ExpeditionType.js.map
